<template>
  <div class="mall-side">
    <second-menu-link-content>
      <template v-slot:header>
        <span>侧边菜单</span>
      </template>
      <template v-slot:content>
        <div class="mall-side-main">
          <div class="add-classify">
            <el-button class="btn-blue" @click="visible">添加分类</el-button>
            <el-dialog title="选择分类" :visible.sync="dialogVisible" width="600px" top="25vh">
              <!-- 黑色的线条 -->
              <div class="border"></div>
              <div class="dialog-container">
                <el-checkbox-group v-model="checkList">
                  <el-checkbox
                    :label="value"
                    v-for="(value,index) in datas"
                    :key="index"
                  >{{ value.cateName }}</el-checkbox>
                </el-checkbox-group>
                <div class="button">
                  <el-button class="btn-white" @click="reset">取消</el-button>
                  <el-button class="btn-blue" @click="save">保存</el-button>
                </div>
              </div>
            </el-dialog>
          </div>
          <div class="side-container">
            <div class="all">
              <div class="left">
                <svg
                  class="icon"
                  style="margin-right:8px;"
                  viewBox="0 0 1316 1024"
                  version="1.1"
                  p-id="3862"
                  width="18"
                  height="18"
                >
                  <path
                    d="M38.619429 148.626286a84.260571 84.260571 0 1 0 168.521142 0 84.260571 84.260571 0 0 0-168.521142 0zM470.454857 222.354286H1202.468571a76.068571 76.068571 0 0 0 75.483429-75.483429c0-42.130286-35.108571-73.728-75.483429-73.728H470.454857A76.068571 76.068571 0 0 0 394.971429 148.626286c0 42.130286 33.353143 73.728 75.483428 73.728zM38.619429 512a84.260571 84.260571 0 1 0 168.521142 0A84.260571 84.260571 0 0 0 38.619429 512zM1202.468571 438.272H470.454857A76.068571 76.068571 0 0 0 394.971429 513.755429c0 42.130286 33.353143 75.483429 75.483428 75.483428H1202.468571a76.068571 76.068571 0 0 0 75.483429-75.483428 76.068571 76.068571 0 0 0-75.483429-75.483429z m-1163.849142 438.857143a84.260571 84.260571 0 1 0 168.521142 0 84.260571 84.260571 0 0 0-168.521142 0zM1202.468571 801.645714H470.454857A76.068571 76.068571 0 0 0 394.971429 877.129143c0 42.130286 33.353143 75.483429 75.483428 75.483428H1202.468571a76.068571 76.068571 0 0 0 75.483429-75.483428 76.068571 76.068571 0 0 0-75.483429-75.483429z"
                    fill="#919398"
                    p-id="3863"
                  />
                </svg>
                <span>全部商品分类</span>
              </div>
              <svg
                class="icon"
                style
                viewBox="0 0 1638 1024"
                version="1.1"
                p-id="2111"
                width="18"
                height="18"
              >
                <path
                  d="M89.088 205.4144L205.1072 89.6l729.4976 729.4976-115.8144 115.712z"
                  fill="#919398"
                  p-id="2112"
                />
                <path
                  d="M704.2048 818.5856L1433.7024 89.088 1549.6192 204.8 820.1216 934.4z"
                  fill="#919398"
                  p-id="2113"
                />
              </svg>
            </div>
            <ul class="list">
              <li class="list-child" v-for="(value,index) in lists" :key="index">
                <span class="tit">{{ value.name }}</span>
                <svg
                  v-if="value.children.length > 0"
                  class="icon"
                  style
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  p-id="2236"
                  width="12"
                  height="12"
                >
                  <path
                    d="M307.6096 998.7072L230.4 921.4976 716.8 435.0976l77.1072 77.312z"
                    fill="#919398"
                    p-id="2237"
                  />
                  <path
                    d="M716.3904 588.5952L229.9904 102.4l77.312-77.2096 486.4 486.4z"
                    fill="#919398"
                    p-id="2238"
                  />
                </svg>
                <span v-else @click="remove(value.id)" class="delet">
                  <i class="el-icon-close" />
                </span>
                <div class="menu-child">
                  <ul>
                    <li
                      class="second-container"
                      v-for="(value2,index2) in value.children"
                      :key="index2"
                    >
                      <div class="second-label">
                        <el-tag closable type="info" @close="remove(value2.id)">
                          <p>{{ value2.name }}</p>
                        </el-tag>
                      </div>
                      <div class="third-container">
                        <el-tag
                          v-for="(tag,index3) in value2.children"
                          :key="index3"
                          closable
                          :disable-transitions="true"
                          @close="remove(tag.id)"
                          type="info"
                        >
                          <p>{{tag.name}}</p>
                        </el-tag>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBCommodity from 'models/db/commodity.js';
import DBMall from 'models/db/mall.js';
const dbCommodity = new DBCommodity();
const dbMall = new DBMall();
export default {
  data() {
    return {
      datas: [], //
      lists: [],
      checkList: [],
      dialogVisible: false
    };
  },
  components: {
    SecondMenuLinkContent
  },
  beforeMount() {
    this.getGoodsClassify();
    this.getSide();
  },
  methods: {
    // 获取商品分类数据
    getGoodsClassify() {
      dbCommodity.getDBGoodsClassify().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            if (i.cateLevel != 0) {
              obj.cateLevel = i.cateLevel
              obj.cateName = i.cateName
              obj.children = i.children
              obj.createTime = i.createTime
              obj.dateLimit = i.dateLimit
              obj.headWeight = i.headWeight
              obj.id = i.id
              obj.parentId = i.parentId
              obj.siteId = i.siteId
              obj.tailWeight = i.tailWeight
              obj.weight = i.weight
              arr.push(obj)
            }
          })
          this.datas = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取侧边栏数据
    getSide() {
      dbMall.postDBSide().then(res => {
        if (res.success) {
          this.lists = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 显示弹窗
    visible() {
      this.dialogVisible = true;
    },
    // 重置按钮
    reset() {
      this.checkList = [];
      this.dialogVisible = false;
    },
    // 保存按钮
    save() {
      let cateIds = [];
      for (let i = 0; i < this.checkList.length; i++) {
        cateIds.push(this.checkList[i].id);
      }
      dbMall.postDBAddSide(cateIds).then(res => {
        if (res.success) {
          this.getSide();
          this.dialogVisible = false;
          this.checkList = [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 删除标签
    remove(id) {
      dbMall.postDBDeleteSide(id).then(res => {
        if (res.success) {
          this.getSide();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mall-side {
  width: 100%;
  height: 100%;
  .delet {
    cursor: pointer;
  }
  .mall-side-main {
    .add-classify {
      margin-bottom: 24px;
      .el-button {
        width: 128px;
        letter-spacing: 2px;
      }
    }
    .side-container {
      position: relative;
      font-size: 14px;
      color: #606266;
      margin-bottom: 32px;
      .all {
        box-sizing: border-box;
        padding: 0 12px;
        width: 200px;
        height: 40px;
        border: 1px solid rgba(228, 228, 228, 1);
        border-bottom: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 20px;
        }
      }
      .list {
        box-sizing: border-box;
        width: 200px;
        height: 400px;
        border: 1px solid rgba(228, 228, 228, 1);
        .list-child {
          box-sizing: border-box;
          height: 40px;
          padding: 0 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .menu-child {
            box-sizing: border-box;
            position: absolute;
            width: 780px;
            height: 400px;
            overflow: auto;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(228, 228, 228, 1);
            border-left: 0;
            top: 40px;
            left: 200px;
            padding-right: 19px;
            display: none;
            .second-container {
              display: flex;
              .el-tag {
                color: #606266;
                border: 1px solid rgba(145, 147, 152, 1);
                background: #fff;
                display: flex;
                align-items: center;
                p {
                  display: inline-block;
                  max-width: 80px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
              .second-label {
                width: 130px;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .third-container {
                flex: 1;
                padding-top: 14px;
                padding-left: 19px;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                box-sizing: border-box;
                border-bottom: 1px solid #e4e4e4;
                .el-tag {
                  margin-bottom: 13px;
                  margin-right: 16px;
                }
              }
            }
          }
        }
        .list-child:hover {
          background: rgba(235, 237, 241, 1);
          border-top: 1px solid rgba(228, 228, 228, 1);
          border-bottom: 1px solid rgba(228, 228, 228, 1);
          .tit {
            color: #3d74f2;
          }
          svg {
            path {
              fill: #3d74f2;
            }
          }
          .menu-child {
            display: block;
          }
        }
        > :first-child:hover {
          border-top: 0;
          padding-top: 1px;
        }
      }
    }
    .save {
      position: absolute;
      display: flex;
      width: 100%;
      height: 32px;
      bottom: 6px;
      justify-content: center;
      .el-button {
        width: 96px;
        letter-spacing: 4px;
      }
    }
  }
}
</style>
<style lang="scss">
.mall-side {
  .mall-side-main {
    .add-classify {
      .el-dialog {
        border-radius: 4px;
        .el-dialog__header {
          padding: 0 16px;
          line-height: 48px;
          color: #606266;
          font-family: "PingFangSC-Medium";
          letter-spacing: 1px;
          .el-dialog__title {
            font-size: 16px;
            color: #606266;
            font-weight: 500;
          }
          .el-dialog__headerbtn {
            top: 15px;
          }
        }
        .el-dialog__body {
          padding: 0 16px 16px 16px;
          .border {
            border-bottom: 1px solid #f7f7f7;
            margin-bottom: 16px;
          }
          .dialog-container {
            .el-checkbox-group {
              display: flex;
              flex-wrap: wrap;
              .el-checkbox {
                width: 188px;
                margin: 0;
                margin-bottom: 10px;
                min-height: 16px;
                display: flex;
                align-items: center;
                margin-bottom: 30px;
                .el-checkbox__input {
                  height: 16px;
                  .el-checkbox__inner {
                    width: 16px;
                    height: 16px;
                  }
                }
                .el-checkbox__label {
                  width: 160px;
                  min-height: 16px;
                  line-height: 16px;
                  font-size: 12px;
                  color: #606266;
                  white-space: pre-line;
                }
              }
            }
            .button {
              display: flex;
              align-items: center;
              justify-content: center;
              padding-top: 6px;
              .el-button {
                width: 96px;
                letter-spacing: 4px;
              }
              .el-button.btn-blue {
                margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
